import { gql, useQuery } from '@apollo/client';

const gqlQueryFilter = gql`
    query overviewRequestBookingState {
        CITRIN_MGT_overviewRequestBookingState @client
    }
`;
const typeName = 'CITRIN_MGT_overviewRequestBookingState';

export type OverviewState = {
    search?: string;
    selectedRequestBookingStatus?: string[];
    page?: number;
};

const initialState: OverviewState = {
    search: '',
    selectedRequestBookingStatus: [],
    page: 1,
};

export const useOverviewLinkState = (): [OverviewState, (newState: OverviewState) => void] => {
    const { data, client } = useQuery(gqlQueryFilter, { fetchPolicy: 'cache-first' });
    const setState = (newState: OverviewState) => {
        client.writeQuery({
            query: gqlQueryFilter,
            data: {
                CITRIN_MGT_overviewRequestBookingState: {
                    value: newState,
                    __typename: typeName,
                },
            },
        });
    };
    return [data?.CITRIN_MGT_overviewRequestBookingState?.value ?? initialState, setState];
};

export default {
    defaults: [
        {
            query: gqlQueryFilter,
            data: {
                CITRIN_MGT_overviewRequestBookingState: {
                    value: initialState,
                    __typename: 'CITRIN_MGT_overviewRequestBookingState',
                },
            },
        },
    ],
};
